module.exports = __webpack_public_path__ + "static/media/3.f75df6f5.jpg";